import React, { useMemo } from "react";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Stack, Typography, Button, useMediaQuery, useTheme } from "@mui/material";
import AtlasContent from "atlas-content/atlas-content.json";
import { fontWeight } from "config/Theme/options";
import { useTranslation } from "react-i18next";
import { IAtlasContent } from "types/types";

import Item from "./Item";
import useAtlasData, { AVAILABLE_QUIZZES } from "./module/useAtlasData";
import Progress from "./Progress";

const Atlas: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));
  const { areasProgress, totalMax, totalDone, answeredQuizzes } = useAtlasData();

  const firstUnansweredQuizUrl = useMemo(() => {
    for (const areaKey of AVAILABLE_QUIZZES) {
      const area = (AtlasContent as IAtlasContent).areas[areaKey];
      if (!area) continue;
      for (const module of area.modules) {
        for (const chapter of module.chapters) {
          if (chapter.quiz && !answeredQuizzes?.urls.includes(chapter.url)) {
            return chapter.url;
          }
        }
      }
    }
    return null;
  }, [AtlasContent, answeredQuizzes]);

  const handleRedirectToFirstUnansweredQuiz = () => {
    window.location.href = `/atlas/${firstUnansweredQuizUrl}`;
  };

  const handleRedirectToAtlas = () => {
    window.location.href = `/atlas`;
  };

  return (
    <>
      <Stack direction={"row"} justifyContent={"space-between"} spacing={2}>
        <Stack spacing={isMdDown ? 2 : 0.75} width={isMdDown ? "100%" : undefined}>
          <Typography
            fontSize={"1.375rem"}
            fontWeight={fontWeight.extraBold}
            fontFamily={"Nunito"}
            sx={{ cursor: "pointer" }}
            onClick={handleRedirectToAtlas}>
            {t("bitcoinerChallenge.atlas.title")}
          </Typography>
          {isMdDown && (
            <Progress currentXP={totalDone} maxXP={totalMax} onClick={handleRedirectToAtlas} maxWidth="100%" />
          )}
          {firstUnansweredQuizUrl && (
            <Button
              variant="contained"
              size="small"
              endIcon={<KeyboardArrowRightIcon />}
              onClick={handleRedirectToFirstUnansweredQuiz}>
              {t("bitcoinerChallenge.atlas.nextQuiz")}
            </Button>
          )}
        </Stack>
        {!isMdDown && <Progress currentXP={totalDone} maxXP={totalMax} onClick={handleRedirectToAtlas} />}
      </Stack>
      <Stack spacing={3} mt={3}>
        {AVAILABLE_QUIZZES.map((areaKey) => {
          const { title, max, done } = areasProgress[areaKey] || {};
          if (!max) return null;

          return <Item key={areaKey} title={title} url={areaKey} max={max} done={done} />;
        })}
      </Stack>
    </>
  );
};

export default Atlas;
